var _path, _path2, _path3, _path4, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageOnMini(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 30 30",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24.4 2.2c-2.9 0-5.3 2.4-5.3 5.3h-17v12.8h3.7v3.1l3.1-3.1h15.5v-7.4c2.9 0 5.3-2.4 5.3-5.3s-2.4-5.4-5.3-5.4z",
    className: "icon-white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.9 13.5h3.5v3.5h-3.5z",
    className: "icon-highlight"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7.8 13.5h3.5v3.5h-3.5z",
    className: "icon-highlight"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "icon-highlight",
    d: "m24.4 12.9v7.4h-15.5l-3.1 3.1v-3.1h-3.7v-12.7h16.9c0-.6.1-1.2.3-1.8h-19v16.4h3.7v5.6l5.6-5.6h16.5v-9.6c-.5.1-1.1.3-1.7.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.4,
    cy: 7.6,
    className: "icon-highlight",
    r: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageOnMini);
export default __webpack_public_path__ + "static/media/message_on_mini.56651f7b.svg";
export { ForwardRef as ReactComponent };